if (!customElements.get('freight-tag-card-button')) {
  class FreightTagCardButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.card__freight-tag');
      if (!this.button) return;

      this.onButtonClick = this.onButtonClick.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);

      this.button.addEventListener('click', this.onButtonClick);
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
    }

    onButtonClick(event) {
      event.preventDefault();
      event.stopPropagation();
      var isOpen = this.classList.toggle('is-open');
      this.button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    onDocumentClick(event) {
      if (this.contains(event.target)) return;
      this.close();
    }

    onKeydown(event) {
      if (event.key === 'Escape') this.close();
    }

    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      if (this.button) this.button.setAttribute('aria-expanded', 'false');
    }
  }

  customElements.define('freight-tag-card-button', FreightTagCardButton);
}
